function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import styles from './RecordCompareSelectAll.module.scss';
import SelectLinkCss from '../SelectLinkCss/RecordCompareSelectLinkCss';
import ThemeContext from '../../../ThemeContext';
import AnchorButton from '../../../Buttons/AnchorButton/AnchorButton';
import ButtonLabel from '../../../Buttons/ButtonLabel/ButtonLabel';
export default function SelectAll(_ref) {
  var _ref$i18nKey = _ref.i18nKey,
    i18nKey = _ref$i18nKey === void 0 ? '@dm/components.record-compare.labels.select-all' : _ref$i18nKey,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["i18nKey", "className"]);
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectLinkCss, {
    className: "".concat(styles.select, " ").concat(styles[theme])
  }), /*#__PURE__*/React.createElement(AnchorButton, Object.assign({
    className: "".concat(styles.select, " ").concat(className || '', " ").concat(styles[theme])
  }, props), /*#__PURE__*/React.createElement(ButtonLabel, {
    i18nKey: i18nKey
  })));
}